var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelAll14 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "#FF3CA0",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M4.5 9c.278 0 .5.224.5.5v1c0 .278-.224.5-.5.5h-1a.5.5 0 0 1-.5-.5v-1c0-.278.224-.5.5-.5zm3 0c.278 0 .5.224.5.5v1c0 .278-.224.5-.5.5h-1a.5.5 0 0 1-.5-.5v-1c0-.278.224-.5.5-.5zm3 0c.278 0 .5.224.5.5v1c0 .278-.224.5-.5.5h-1a.5.5 0 0 1-.5-.5v-1c0-.278.224-.5.5-.5zm-6-3c.278 0 .5.224.5.5v1c0 .278-.224.5-.5.5h-1a.5.5 0 0 1-.5-.5v-1c0-.278.224-.5.5-.5zm3 0c.278 0 .5.224.5.5v1c0 .278-.224.5-.5.5h-1a.5.5 0 0 1-.5-.5v-1c0-.278.224-.5.5-.5zm3 0c.278 0 .5.224.5.5v1c0 .278-.224.5-.5.5h-1a.5.5 0 0 1-.5-.5v-1c0-.278.224-.5.5-.5zm-6-3c.278 0 .5.224.5.5v1c0 .278-.224.5-.5.5h-1a.5.5 0 0 1-.5-.5v-1c0-.278.224-.5.5-.5zm3 0c.278 0 .5.224.5.5v1c0 .278-.224.5-.5.5h-1a.5.5 0 0 1-.5-.5v-1c0-.278.224-.5.5-.5zm3 0c.278 0 .5.224.5.5v1c0 .278-.224.5-.5.5h-1a.5.5 0 0 1-.5-.5v-1c0-.278.224-.5.5-.5z"
}))));
export default SvgChannelAll14;